import { getDashboardPathByPlatform } from 'src/utils/appDeviceBridge'

/** 与 UserLayout 清空侧栏菜单的绑定/选平台路径对齐（长路径优先匹配） */
const BINDING_FLOW_PATHS = [
  '/android/local/setup',
  '/android/nodevice-setup',
  '/android/classification',
  '/android/setup',
  '/ios/extreme-verification',
  '/ios/setup',
  '/setup'
]

/**
 * 当前是否处于绑定向导 / 选平台流程（含可选 locale 前缀，如 /fr/setup）。
 * @param {string} [pathname]
 * @returns {boolean}
 */
export const isBindingFlowPath = pathname => {
  if (!pathname) return false

  const path = String(pathname).split('?')[0].replace(/\/$/, '') || '/'

  return BINDING_FLOW_PATHS.some(p => {
    if (path === p) return true
    if (!path.endsWith(p)) return false

    const prefix = path.slice(0, -p.length)

    // /fr/setup、/it-ch/ios/setup 等
    return /^\/[a-z]{2}(-[a-z]+)?$/i.test(prefix)
  })
}

/**
 * 若当前在绑定流，清 ontBindOrder 并跳到对应 Dashboard。
 * @param {Object} params
 * @param {{ pathname?: string, asPath?: string, push?: Function }} [params.router]
 * @param {string} [params.platformType]
 * @returns {boolean} 是否已执行离开跳转
 */
export const leaveBindingFlowIfNeeded = ({ router, platformType } = {}) => {
  const pathname =
    router?.pathname ||
    (typeof router?.asPath === 'string' ? router.asPath.split('?')[0] : '') ||
    (typeof window !== 'undefined' ? window.location.pathname : '')

  if (!isBindingFlowPath(pathname)) return false

  try {
    localStorage.removeItem('ontBindOrder')
  } catch {
    // ignore
  }

  const target = getDashboardPathByPlatform(platformType)

  if (typeof router?.push === 'function') {
    router.push(target)
  } else if (typeof window !== 'undefined') {
    window.location.assign(target)
  }

  return true
}
